// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3eda0dd7","728":"2eb77a4a","780":"3722bea0"}[chunkId] + ".chunk.js";
};